import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'verify-card',
  name: '验真卡片',
  icon: '验',
  group: '公证组件',
  description: '电子公证书验真入口。',
  defaultProps: {
    title: '公证书验真',
    subtitle: '输入编号核验证书真实性',
    buttonText: '立即验真',
    link: '/pages/gongzheng/verify'
}
}
